module.exports = __webpack_public_path__ + "img/popup-mlbb-id-10diamond.52e829e.png";